import { observable, action } from 'mobx'
import {
  convertToRegularBarcodeIfBatch,
  isBatchBarcode,
  getBatchNameFromBarcode,
  cleanBarcode,
} from '@getgreenline/homi-shared'

type BarcodeCallback = (value: string, batchNumber?: string, e?: KeyboardEvent) => void

// Reference: https://github.com/pridemusvaire/barcode-scanner-js
// EDIT: This is a custom implementation using timers
class BarcodeStore {
  readonly CHAR_MIN_LENGTH = 3

  // Amount of milliseconds between keystrokes before clearing the barcode character array. Socket mobile averages 20-40ms per keystroke
  @observable
  timeout = 100

  private ALLOWED_REGEX = /^[a-zA-Z0-9-\s]*$/

  private characters: string[] = []

  @observable
  private prevBarcodeCallback?: BarcodeCallback

  @observable
  barcodeCallback?: BarcodeCallback

  timer?: NodeJS.Timer

  constructor() {
    window.addEventListener('keypress', this.handleKeyDown.bind(this))
  }

  handleKeyDown(e: KeyboardEvent) {
    if (this.timer) {
      clearTimeout(this.timer)
    }

    if (String.fromCharCode(e.which) && this.ALLOWED_REGEX.test(String.fromCharCode(e.which))) {
      this.characters.push(String.fromCharCode(e.which))
    }

    this.timer = setTimeout(() => {
      if (this.characters.length >= this.CHAR_MIN_LENGTH) {
        const cleanedBarcode = cleanBarcode(this.characters.join(''))

        if (cleanedBarcode.length > this.CHAR_MIN_LENGTH) {
          const convertedBarcode = convertToRegularBarcodeIfBatch(cleanedBarcode)
          console.log(`Barcode: ${convertedBarcode}`)

          if (isBatchBarcode(cleanedBarcode)) {
            console.log(`Converted from batch: ${convertedBarcode}`)
          }

          this.barcodeCallback?.(convertedBarcode, getBatchNameFromBarcode(cleanedBarcode), e)
        }
      }

      this.characters = []
    }, this.timeout)
  }

  @action
  setTimeoutDuration = (timeout = 100) => {
    this.timeout = timeout
  }

  @action
  setBarcodeCallback = (barcodeCallback?: BarcodeCallback) => {
    this.storePrevBarcodeCallback()

    this.barcodeCallback = barcodeCallback
  }

  @action
  setBackToPrevBarcodeCallback = () => {
    this.barcodeCallback = this.prevBarcodeCallback
  }

  @action
  private storePrevBarcodeCallback = () => {
    this.prevBarcodeCallback = this.barcodeCallback
  }
}

export const barcodeStore = new BarcodeStore()
